import { IThemeRGB } from "../../types";

// Used as default
export const tailwindColorTheme: IThemeRGB = {
  "rgb-primary": "12, 26, 50", // ocean-800
  "rgb-acc-1": "252, 66, 201", // pink-400
  "rgb-background-acc-1": "24, 33, 52", // space-700
  "rgb-background-acc-start": "31, 41, 66", // space-600
  "rgb-button-1": "61, 145, 240", // sky-400
  "rgb-link-1": "39, 105, 180", // sky-600
  "rgb-button-2": "39, 105, 180", // sky-600
  "rgb-link-2": "61, 145, 240", // sky-400
  "rgb-link-light": "109, 176, 252", // sky-300
  "rgb-code-background": "30, 40, 66", // space-600
};
